import React, { useEffect, useState } from "react";
import axios from "axios";
import Mou1 from "../../assets/partnersSupporters/mou1.png";
import Mou2 from "../../assets/partnersSupporters/mou2.png";
import Mou11 from "../../assets/partnersSupporters/mou11.png";
import Mou22 from "../../assets/partnersSupporters/mou22.png";

interface ApiResponse {
  _id: string;
  image: string[];
  heading: string;
  description: string;
  tag: string;
}

export default function MouGovernment() {
  const [mouList, setMouList] = useState<ApiResponse[]>([]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LOCAL_URL}/api/common-layout?tag=mou`
        );
        const raw = response.data.data;
        setMouList(Array.isArray(raw) ? raw : raw ? [raw] : []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetails();
  }, []);

  return (
    <section className="lg:bg-teal bg-white blade-top-padding-lg blade-bottom-padding-lg">
      <div className="w-container-xl">

        {/* ── Dynamic MOU sections (managed from admin) ── */}
        {mouList.map((data, idx) => (
          <div key={data._id}>
            <div className={idx > 0 ? "blade-top-margin" : ""}>
              <h1 className="font-lato-bold lg:text-white text-darkGreen">
                {data.heading}
              </h1>
            </div>

            <hr className="border-b border-white border-opacity-[28%]" />

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 mt-8">
              {/* Left image — desktop only */}
              {data.image?.[2] && (
                <div className="lg:col-span-1 lg:block hidden">
                  <img
                    className="h-full w-full object-cover object-center"
                    src={`${process.env.REACT_APP_LOCAL_URL}/${data.image[2].replace(/\\/g, "/")}`}
                    alt={`${data.heading} left`}
                  />
                </div>
              )}

              {/* Right main image */}
              {data.image?.[0] && (
                <div className={data.image?.[2] ? "lg:col-span-3" : "lg:col-span-4"}>
                  <img
                    className="h-full w-full object-cover"
                    src={`${process.env.REACT_APP_LOCAL_URL}/${data.image[0].replace(/\\/g, "/")}`}
                    alt={`${data.heading} main`}
                  />
                </div>
              )}

              {/* Mobile-only image */}
              {data.image?.[1] && (
                <div className="lg:hidden sm:mt-4 block">
                  <img
                    src={`${process.env.REACT_APP_LOCAL_URL}/${data.image[1].replace(/\\/g, "/")}`}
                    className="h-full w-[40%]"
                    alt={`${data.heading} mobile`}
                  />
                </div>
              )}
            </div>

            <h4 className="font-lato-regular lg:blade-top-margin-sm blade-top-margin lg:text-white text-black/80 sm:max-w-[100%] opacity-80" style={{ whiteSpace: "pre-line" }}>
              {data.description}
            </h4>
          </div>
        ))}

       

      </div>
    </section>
  );
}